export const navigateWithQueryParams = (path: string, history: any) =>
  history.push(path + history.location.search);
